import { App } from 'vue';
import { useMenuStore } from '@/store/menu';
import { formatTime, toThousands } from '@toy/utils';

interface LabelListItem {
    value: string;
    label: string;
}

function getLabelByVal(arr: LabelListItem[], val: string) {
  const item = arr.find(it => String(it.value) === String(val)) as LabelListItem || {};
  return item.label || '';
}

export const ossUrl = (url?: string | number, w = '80') => {
  if (!url) return '';

  return `${url}?x-oss-process=image/resize,w_${w},m_lfit`;
};

export const filters = {
  // 获取枚举标签
  getEnumLabel(list: LabelListItem[], val: string): string {
    return getLabelByVal(list, val);
  },
  // 时间格式化
  formatTime(date: string | number | Date, fmt = 'YYYY-MM-DD HH:mm:ss'): string {
    return formatTime(date, fmt);
  },
  // 金额格式化
  toThousands(num: number | string, defaultValue = '-'): string {
    return toThousands(num, defaultValue);
  },
  ossUrl,
};
export const has = (code: string):boolean => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  const { authButtonList } = useMenuStore();
  return authButtonList.includes(code);
};
export type IFilters = typeof filters;
export type IHas = typeof has;
export default {
  install(app: App) {
    const { globalProperties } = app.config;

    globalProperties.$has = has;

    globalProperties.$filters = filters;
  },
};
